import {Component, Input} from '@angular/core'
import {IconDefinition} from '@fortawesome/fontawesome-svg-core'

/**
 * Provide a child node with "content=value" for the value
 */
@Component({
  selector: 'cft-display',
  templateUrl: './display.component.html',
  styles: [':host {display: inline-block}'],
})
export class DisplayComponent {
  @Input() icon?: IconDefinition
  @Input() title?: string
  @Input() description?: string
}
